import { render, staticRenderFns } from "./force-resisting-system.vue?vue&type=template&id=085ef274"
import script from "./force-resisting-system.vue?vue&type=script&lang=js"
export * from "./force-resisting-system.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports